import axios from 'axios'

export default axios.create({ baseURL: window.app.orderhistory.api_base })
